//
//
//
//
//
//
//

var script = {
  name: "MarqueeSlider",
  props: {
    autoWidth: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    id: {
      type: String,
      required: true,
      default: () => {
        return "id";
      }
    },
    paused: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    repeat: {
      type: Number,
      default: () => {
        return 10;
      }
    },
    reverse: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    space: {
      type: Number,
      default: () => {
        return 200;
      }
    },
    speed: {
      type: Number,
      default: () => {
        return 1500;
      }
    },
    width: {
      type: Number,
      default: () => {
        return 100;
      }
    }
  },
  data() {
    return {
      container: null,
      containerWidth: 0,
      items: [],
      itemsLength: 0,
      itemsWidth: []
    };
  },
  computed: {
    style() {
      return `
        animation-duration: ${this.speed}ms;
        animation-direction: ${this.reverse ? "reverse" : "normal"};
        animation-play-state: ${this.paused ? "paused" : "running"};
      `;
    }
  },
  mounted() {
    this.setContainer();
    this.setItems();
    this.setItemsLength();
    this.calculateContainerWidth();
    this.setContainerWidth();
    this.cloneItems();
  },
  methods: {
    calculateContainerWidth() {
      for (let index = 0; index < this.itemsLength; index++) {
        this.itemsWidth.push(this.items[index].offsetWidth);
        this.setItemSpace(index);
        if (this.autoWidth) {
          // if we are not using width specified by the user, we are setting the object-fit:contain for the images
          this.setImageObjectFit(index);
        } else {
          // if the user use the width property and want all items to be equal, the component will set the minWidth of the items
          this.setItemWidth(index);
        }
      }
      this.containerWidth = this.itemsWidth.reduce((a, b) => a + b, 0);
    },
    cloneItems() {
      const repeatCounter = this.getRepeatCounter();
      for (let index = 0; index < repeatCounter; index++) {
        this.container.appendChild(this.items[index].cloneNode(true));
      }
    },
    getRepeatCounter() {
      return this.items.length * this.repeat;
    },
    setItems() {
      // get all childrens that will be put inside the slot of the component
      this.items = this.container.children;
    },
    setItemsLength() {
      this.itemsLength = this.items.length;
    },
    setItemSpace(index) {
      this.items[index].style.marginRight = `${this.space}px`;
    },
    setItemWidth(index) {
      this.items[index].style.minWidth = `${this.width}px`;
    },
    setImageObjectFit(index) {
      this.items[index].style.objectFit = "contain";
    },
    setContainer() {
      this.container = document.querySelector(`#${this.id} .${this.$style.marqueeSliderContainer}`);
    },
    setContainerWidth() {
      if (this.autoWidth) {
        this.container.style.width = `${this.itemsLength * (this.containerWidth / this.itemsLength + this.space)}px`;
      } else {
        this.container.style.width = `${this.itemsLength * (this.width + this.space)}px`;
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.marqueeSlider,
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    class: _vm.$style.marqueeSliderContainer,
    style: _vm.style
  }, [_vm._t("default")], 2)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-3942214c_0", {
    source: ".src-components-marqueeSlider-3ljS{overflow:hidden}.src-components-marqueeSliderContainer-1UFI{width:100%;animation-name:src-components-animation-2PZg;animation-timing-function:linear;animation-iteration-count:infinite;display:flex}@keyframes src-components-animation-2PZg{0%{transform:translateX(0)}100%{transform:translateX(-100%)}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "marqueeSlider": "src-components-marqueeSlider-3ljS",
      "marqueeSliderContainer": "src-components-marqueeSliderContainer-1UFI",
      "animation": "src-components-animation-2PZg"
    }
  });
};
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  VueMarqueeSlider: __vue_component__$1
});

// Import vue components

// install function executed by Vue.use()
const install = function installVueMarqueeSlider(Vue) {
  Object.entries(components).forEach(_ref => {
    let [componentName, component] = _ref;
    Vue.component(componentName, component);
  });
};

export { __vue_component__$1 as VueMarqueeSlider, install as default };
